import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen is mobile

  const [imgError, setImgError] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleImageError = () => {
    setImgError(true);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const renderDesktopLinks = () => (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {user && (
        <>
          <Button
            component={Link}
            to="/courses"
            sx={{
              color: '#FFFFFF',
              textTransform: 'none',
              '&:hover': { backgroundColor: '#FFFFFF', color: '#000000' }, 
            }}
          >
            Courses
          </Button>
          <Button
            component={Link}
            to="/my-courses"
            sx={{
              color: '#FFFFFF',
              textTransform: 'none',
              '&:hover': { backgroundColor: '#FFFFFF', color: '#000000' }, 
            }}
          >
            My Courses
          </Button>
        </>
      )}
      {!user ? (
        <Button
          component={Link}
          to="/login"
          sx={{
            color: '#FFFFFF',
            textTransform: 'none',
            '&:hover': { backgroundColor: '#FFFFFF', color: '#000000' }, 
          }}
        >
          Login
        </Button>
      ) : (
        <IconButton onClick={handleLogout} sx={{ color: '#FFFFFF' }}>
          {!imgError && user?.photoURL ? (
            <img
              src={user.photoURL}
              alt="User Profile"
              onError={handleImageError}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <AccountCircleIcon sx={{ color: '#FFFFFF' }} />
          )}
        </IconButton>
      )}
    </Box>
  );

  const renderMobileDrawer = () => (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={toggleDrawer(false)}
      sx={{
        '& .MuiDrawer-paper': { backgroundColor: '#000000', color: '#FFFFFF' }, // Black background, white text
      }}
    >
      <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
        <List>
          {user && (
            <>
              <ListItem button component={Link} to="/courses">
                <ListItemText primary="Courses" sx={{ color: '#FFFFFF' }} /> {/* White text */}
              </ListItem>
              <ListItem button component={Link} to="/my-courses">
                <ListItemText primary="My Courses" sx={{ color: '#FFFFFF' }} /> {/* White text */}
              </ListItem>
            </>
          )}
          {!user ? (
            <ListItem button component={Link} to="/login">
              <ListItemText primary="Login" sx={{ color: '#FFFFFF' }} /> {/* White text */}
            </ListItem>
          ) : (
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Logout" sx={{ color: '#FFFFFF' }} /> {/* White text */}
            </ListItem>
          )}
        </List>
      </Box>
    </Drawer>
  );

  return (
    <AppBar position="fixed" sx={{ backgroundColor: '#000000' }}> {/* Black background */}
      <Toolbar>
        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img
            src="/logo.jpeg"
            alt="Valarchi Logo"
            style={{ height: '40px', marginRight: '10px', borderRadius: '4px' }}
          />
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              textDecoration: 'none',
              color: '#FFFFFF', // White text
              fontWeight: 'bold',
              fontSize: '24px',
            }}
          >
            Valarchi
            {/* {user ? user.displayName : 'Valarchi'} */}
          </Typography>
        </Box>

        {/* Render links based on device type */}
        {!isMobile ? (
          renderDesktopLinks()
        ) : (
          <>
            <IconButton onClick={toggleDrawer(true)} sx={{ color: '#FFFFFF' }}>
              <MenuIcon />
            </IconButton>
            {renderMobileDrawer()}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
